import { CulturalRoute } from '../dtos/culturalRoute';

export class CulturalRouteVo extends CulturalRoute{
    public availabilitiesToggle = true;

    constructor() {
        super();
    }
}